import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { ParagraphNormal } from './Paragraph';
import themeColors from '../assets/styles/themeColors';

const List = styled.ul`
  position: relative;
  list-style: initial;
`;
export const ListItem = styled.li`
  display: flex;
  margin: 8px 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin-top: 8px;
    background-color: ${themeColors.colorTextSecondary};
  }
`;
export const ListParagraph = styled(ParagraphNormal)`
  position: relative;
  left: 16px;
`;

const SelectionList = ({ data }) => {
  const { t } = useTranslation();

  return (
    <List>
      {data.map(({ title, weight }) => (
        <ListItem key={title}>
          <ListParagraph weight={weight}>{t(title)}</ListParagraph>
        </ListItem>
      ))}
    </List>
  );
};

SelectionList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      weight: PropTypes.number,
    }),
  ).isRequired,
};

export default SelectionList;
